/* eslint-disable react-hooks/exhaustive-deps */
import { FunctionComponent as F, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PageHeadline from '../../components/UI/Text/PageHeadline';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import Button from "../../components/UI/Button/Button";
import SearchIcon from '@mui/icons-material/Search';
import { searchTopics } from '../../core/http/ref';
import { TOPIC } from '../../core/router/paths';
import { ITopic } from "@protoplan/types";




const MmIndex: F = () =>
{
  const navigate = useNavigate();;

  const [searchParams, setSearchParams] = useSearchParams();

  const [query, setQuery] = useState(searchParams.get("query") || "");
  const [topics, setTopics] = useState<ITopic[] | undefined>(undefined);

  useEffect(() =>
  {
    if(!query)
      return;

    submitSearch();
  }, []);

  async function submitSearch()
  {
    setTopics(undefined);

    if(query === "")
      setTopics([]);
    else
      setTopics(await searchTopics(query));

    setSearchParams({ query });
  }

  async function handleFormSubmit(event: React.FormEvent<HTMLFormElement>)
  {
    event.preventDefault();
    await submitSearch();
  }



  return (
    <Container>
      <Stack
        justifyContent='center'
        alignItems='center'
        spacing={2}>

        <PageHeadline>MM Index</PageHeadline>

        <Box sx={{ width: 650 }}>

          <DialogContent>
            <Typography style={{ fontSize: 30, fontWeight: 600, marginBottom: 24 }}>
              Search for a topic
            </Typography>

            <Stack spacing={2} sx={{ width: '100%' }}>

              <Stack direction='row'>
                <form onSubmit={handleFormSubmit} style={{ marginRight: 12 }}>
                  <TextField
                    size='small'
                    value={query}
                    onChange={event => setQuery(event.target.value)}
                    style={{ width: '400px', display: 'flex' }}
                    placeholder='Search for a topic'
                    inputProps={{ style: {
                      padding: 10,
                      paddingLeft: 16,
                      paddingRight: 6,
                      fontSize: 14 }}}/>
                </form>
                <Button
                  size='medium'
                  startIcon={<SearchIcon />}
                  onClick={submitSearch}
                  label='Search'/>
              </Stack>

              {(() =>
              {
                if(!topics)
                {
                  return <></>;
                }
                else if(topics.length)
                {
                  return (topics.map(t => (
                    <Link
                      key={t.topicId}
                      variant='body2'
                      underline='none'
                      style={{ cursor: 'pointer', color: 'gray' }}
                      onClick={() => navigate(TOPIC + "/" + t.topicId, { state: { topic: t } })} >
                      {t.name}
                    </Link>)));
                }
                else
                {
                  return (
                    <Typography
                      variant='body2'
                      style = {{ userSelect: 'none' }}
                      gutterBottom>
                      {"No topics found for '" + query + "'."}
                    </Typography>);
                }
              })()}

            </Stack>
          </DialogContent>

        </Box>

      </Stack>
    </Container>);
};

export default MmIndex;
